/*
 *
 *  actions
 *
 */

import {
  LOAD_PAYMENT_OUT_DETAILS,
  LOAD_PAYMENT_OUT_DETAILS_SUCCESS,
  LOAD_PAYMENT_OUT_DETAILS_ERROR,
  LOAD_PAYMENT_OUT_SETTLED_LIST,
  LOAD_PAYMENT_OUT_SETTLED_LIST_SUCCESS,
  LOAD_PAYMENT_OUT_SETTLED_LIST_ERROR,
  CREATE_PAYMENT_OUT_DETAILS,
  CREATE_PAYMENT_OUT_DETAILS_SUCCESS,
  CREATE_PAYMENT_OUT_DETAILS_ERROR,
  UPDATE_PAYMENT_OUT_DETAILS,
  UPDATE_PAYMENT_OUT_DETAILS_SUCCESS,
  UPDATE_PAYMENT_OUT_DETAILS_ERROR,
  DELETE_PAYMENT_OUT_DETAILS,
  DELETE_PAYMENT_OUT_DETAILS_SUCCESS,
  DELETE_PAYMENT_OUT_DETAILS_ERROR,
  LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA,
  LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA_SUCCESS,
  LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA_ERROR,
  LOAD_PAYMENT_OUT_DETAILS_REPORT,
  LOAD_PAYMENT_OUT_DETAILS_REPORT_SUCCESS,
  LOAD_PAYMENT_OUT_DETAILS_REPORT_ERROR,
} from "./constants";

// load parties
export function loadPaymentOutList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS,
    paymentDetails,
  };
}

export function loadPaymentOutListSuccess(payment_out_list, success) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_SUCCESS,
    payment_out_list,
    success,
  };
}

export function loadPaymentOutListError(error) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_ERROR,
    error,
  };
}

// load parties
export function loadPaymentOutReportList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_REPORT,
    paymentDetails,
  };
}

export function loadPaymentOutReportListSuccess(payment_out_report, success) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_REPORT_SUCCESS,
    payment_out_report,
    success,
  };
}

export function loadPaymentOutReportListError(error) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_REPORT_ERROR,
    error,
  };
}
// load parties
export function loadPaymentSettledList(paymentDetails) {
  return {
    type: LOAD_PAYMENT_OUT_SETTLED_LIST,
    paymentDetails,
  };
}

export function loadPaymentSettledListSuccess(payment_settled_list, success) {
  return {
    type: LOAD_PAYMENT_OUT_SETTLED_LIST_SUCCESS,
    payment_settled_list,
    success,
  };
}

export function loadPaymentSettledListError(error) {
  return {
    type: LOAD_PAYMENT_OUT_SETTLED_LIST_ERROR,
    error,
  };
}

// load parties
export function createPaymentOutList(paymentDetails) {
  return {
    type: CREATE_PAYMENT_OUT_DETAILS,
    paymentDetails,
  };
}

export function createPaymentOutListSuccess(paymentDetails, success) {
  return {
    type: CREATE_PAYMENT_OUT_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function createPaymentOutListError(error) {
  return {
    type: CREATE_PAYMENT_OUT_DETAILS_ERROR,
    error,
  };
}
// load parties
export function updatePaymentOutList(paymentDetails) {
  return {
    type: UPDATE_PAYMENT_OUT_DETAILS,
    paymentDetails,
  };
}

export function updatePaymentOutListSuccess(paymentDetails, success) {
  return {
    type: UPDATE_PAYMENT_OUT_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function updatePaymentOutListError(error) {
  return {
    type: UPDATE_PAYMENT_OUT_DETAILS_ERROR,
    error,
  };
}
// load parties
export function deletePaymentOutList(paymentDetails) {
  return {
    type: DELETE_PAYMENT_OUT_DETAILS,
    paymentDetails,
  };
}

export function deletePaymentOutListSuccess(paymentDetails, success) {
  return {
    type: DELETE_PAYMENT_OUT_DETAILS_SUCCESS,
    paymentDetails,
    success,
  };
}

export function deletePaymentOutListError(error) {
  return {
    type: DELETE_PAYMENT_OUT_DETAILS_ERROR,
    error,
  };
}

export function loadPaymentOutListRecordsMetaData() {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA,
  };
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadPaymentOutListRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  };
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadPaymentOutListRecordsMetaDataError(error) {
  return {
    type: LOAD_PAYMENT_OUT_DETAILS_RECORDS_META_DATA_ERROR,
    error,
  };
}

const actions = {
  loadPaymentOutList,
  loadPaymentOutListSuccess,
  loadPaymentOutListError,
  loadPaymentOutReportList,
  loadPaymentOutReportListSuccess,
  loadPaymentOutReportListError,

  createPaymentOutList,
  createPaymentOutListSuccess,
  createPaymentOutListError,
  updatePaymentOutList,
  updatePaymentOutListSuccess,
  updatePaymentOutListError,

  deletePaymentOutList,
  deletePaymentOutListSuccess,
  deletePaymentOutListError,

  loadPaymentOutListRecordsMetaData,
  loadPaymentOutListRecordsMetaDataSuccess,
  loadPaymentOutListRecordsMetaDataError,
  loadPaymentSettledList,
  loadPaymentSettledListSuccess,
  loadPaymentSettledListError,
};

export default actions;
